module.exports = __webpack_public_path__ + "static/media/food_false_passive.1d565fe5.jpg";